import { View, Text } from "@react-pdf/renderer";
import { styles } from "./PdfStyles";

/**
 * PdfDataField — mirrors the DOM DataField component.
 *
 * vertical=false (default): "Label  Value" rendered side by side in a row.
 * vertical=true            : Label stacked above Value.
 */
export const PdfDataField = ({
  label = "",
  value = "",
  vertical = false,
  style,
  labelStyle,
  valueStyle,
}) => {
  const displayValue = value !== null && value !== undefined ? String(value) : "";

  if (vertical) {
    return (
      <View style={[{ marginBottom: 3 }, style]}>
        <Text style={[styles.fieldLabel, labelStyle]}>{label}</Text>
        <Text style={[styles.fieldValue, valueStyle]}>{displayValue}</Text>
      </View>
    );
  }

  return (
    <View style={[{ flexDirection: "row", flexWrap: "wrap", marginBottom: 3 }, style]}>
      <Text style={[styles.fieldLabel, labelStyle]}>{label}&nbsp;</Text>
      <Text style={[styles.fieldValue, valueStyle]}>{displayValue}</Text>
    </View>
  );
};
